import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IGetDimensionSettingsRequest extends IBaseRequest {
    treeHandle?: string;
}

export class GetDimensionSettingsRequest extends BaseRequest implements IGetDimensionSettingsRequest {

    public treeHandle?: string;
    constructor(server: string, session: string, treeHandle?: string) {
        super(server, session);
        this.treeHandle = treeHandle;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.treeHandle, 'treeHandle');

        return super.wrapperXml('GetDimensionSettings', parameters);
    }
}
